export enum AddressingLineFormat {
  SIREN = 'SIREN',
  SIREN_SIRET = 'SIREN_SIRET',
}

export interface AddressingLineDefaultProps {
  addressingLineFormat?: AddressingLineFormat
  onAddressingLineFormatChange: (addressingLineFormat: AddressingLineFormat) => void
}
